import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    collections: [],
    is_true:false,
    is_filter_load:false,
    filterPayload: null
}
const AccountCollectionSlice = createSlice({
    name: "collection",
    initialState: initialState,
    reducers: {
        setFilterPayload: (state, action) => {
            state.filterPayload = action.payload
        },
        filterLoad:(state,action)=>{
            state.is_filter_load = action.payload
        },
        showCollection: (state, action) => {
            state.collections = action.payload
        },
        showPdfCollections:(state,action)=>{
            state.is_true = action.payload
        }
    }
})
export const { showCollection ,showPdfCollections,filterLoad, setFilterPayload} = AccountCollectionSlice.actions

export default AccountCollectionSlice.reducer